import { DaymapQuery as l, DaymapInfiniteQuery as b } from "../daymapQuery.js";
var d;
((a) => {
  class m extends l {
    constructor() {
      super(
        ["recentPosts"],
        null,
        "/lms/api/coms/posts/recent",
        null,
        {
          select: (e) => e.map((r) => ({ ...r, SentOn: new Date(r.SentOn) }))
        }
      );
    }
  }
  a.recentPosts = m;
  class p extends l {
    constructor(e) {
      super(
        ["archiveMessages", e.data],
        e,
        "/lms/api/coms/message/archive",
        { method: "PATCH" },
        { enabled: !1 }
      );
    }
  }
  a.archive = p;
  class h extends l {
    constructor(e) {
      super(
        ["thread", e.messageId],
        e,
        `/lms/api/coms/message/${e.messageId}/thread`,
        null
      );
    }
  }
  a.thread = h, ((s) => {
    class e extends l {
      constructor() {
        super(
          ["comsfolders"],
          null,
          "/lms/api/coms/folders",
          null,
          {
            stale: 1e3 * 60 * 10
          }
        );
      }
    }
    s.userFolders = e;
    class i extends l {
      constructor(t) {
        super(
          ["markAllRead"],
          t,
          `/lms/api/coms/folder/${t.folderId}/setallread`,
          { method: "PATCH" },
          { enabled: !1 }
        );
      }
    }
    s.markAllRead = i;
    class r extends l {
      constructor(t) {
        super(
          ["archiveAll"],
          t,
          "/lms/api/coms/folder/archiveall",
          { method: "PATCH" },
          { enabled: !1 }
        );
      }
    }
    s.archiveAll = r;
    class x extends b {
      constructor({ folderId: t, msgsPerPage: n, unreadOnly: o, staleDate: A }) {
        super(
          ["messages", t, n, o, A],
          { folderId: t, msgsPerPage: n, unreadOnly: o },
          "",
          null,
          {
            infiniteQueryUrl: (u) => `/lms/api/coms/folder/${t}?page=${u}&msgsPerPage=${n}${o ? "&unReadOnly=true" : ""}`,
            initialPageParam: 1,
            getNextPageParam: (u, $) => {
              if (u.length === n)
                return $.length + 1;
            },
            stale: 1e3 * 120
          }
        );
      }
    }
    s.messages = x;
  })(a.folders || (a.folders = {}));
  class f extends l {
    constructor() {
      super(
        ["parentMessageContacts"],
        null,
        "/lms/api/coms/messagecontactlist",
        null,
        { stale: 1e3 * 60 * 5 }
      );
    }
  }
  a.parentContacts = f;
  class v extends l {
    constructor({ maxMessages: e = 10 }) {
      super(
        ["bulletins", e],
        { maxMessages: e },
        `/lms/api/coms/folder/bulletins?$maxMessages=${e}`,
        null,
        { stale: 1e3 * 60 * 2 }
      );
    }
  }
  a.bulletins = v;
})(d || (d = {}));
export {
  d as message
};
//# sourceMappingURL=index.js.map
